export enum DateFormat {
  DISPLAY_DATE_TIME = "ccc, LLL do yyyy @h:mmaaa",
  DISPLAY_DATE = "ccc, LLL do yyyy",
  DISPLAY_DATE_TIME_YEAR_VERBOSE = "MMM Do YYYY [at] h:mm a", // Jan. 5th at 6:00 pm
  DISPLAY_DATE_RANGE = "MM/DD/YYYY",
  MONTH_DAY_WRITTEN = "MMM D",
  MONTH_YEAR_WRITTEN = "MMM YYYY",
}
